import { Route, Routes } from "react-router-dom";
import GoodNews from "./GoodNews";

export default function GoodNewsRouter() {
  return (
    <Routes>
      <Route path="/:goodNewsType/" element={<GoodNews />} />
    </Routes>
  );
}
